<template>
  <div class="agreement-container">
    <!-- 标题部分 -->
    <div class="agreement-header">
      <h1>激活助手用户服务协议</h1>
      <div class="effective-dates">
        <p><strong>更新日期:</strong> 2025-6-23</p>
        <p><strong>生效日期:</strong> 2025-6-23</p>
      </div>
    </div>
    
    <!-- 目录导航 -->
    <div class="toc">
      <h2>目录</h2>
      <ul>
        <li v-for="(section, index) in sections" :key="index">
          <a :href="'#' + section.id">{{ section.title }}</a>
        </li>
      </ul>
    </div>
    
    <!-- 主要内容区域 -->
    <div class="agreement-content">
      <!-- 前言 -->
      <section id="preface">
        <h2>前言</h2>
        <p>感谢您使用烟台微步网络科技有限公司提供的产品和/或服务。在完成注册程序或以任何方式使用服务前,请您务必仔细阅读并透彻理解本激活助手服务条款(以下或简称"服务条款")，在确认充分理解后选择接受或不接受本服务条款;一旦您完成"同意条款并注册"或开始以其他方式使用激活助手服务，即表明您已阅读并同意受本服务条款的约束。如您不同意本服务条款或其中任何条款约定,您应不再进行下一步或停止注册程序。</p>
        <p class="important">激活助手再次提示您审慎阅读、充分理解各条款内容，特别是限制或免除责任的相应条款，限制或免除责任条款可能会以加粗或其他醒目形式提示您注意。</p>
      </section>
      
      <!-- 签约主体 -->
      <section id="subject">
        <h2>一、签约主体以及协议范围</h2>
        <p>激活助手服务条款是您与烟台微步网络科技有限公司(以下简称"微步"或者"我们")就使用激活助手服务(包含为您提供App页面信息浏览、账户注册服务等，以下简称"本服务")而订立的有效合约。</p>
      </section>
      
      <!-- 账户的注册、使用与安全 -->
      <section id="account">
        <h2>二、账户的注册、使用与安全</h2>
        
        <h3>2.1.注册的资格</h3>
        <p>2.1.1.您确认，在您完成注册程序或以其他激活助手允许的方式实际使用本服务时，您应当是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织(以下或简称为"您")。</p>
        <p>2.1.2.若您是未成年人或限制民事行为能力人，则您不具备前述主体资格，您及您的监护人应承担因您的不当注册行为而导致的一切后果。</p>
        <p>2.1.3.您还需确保您不是任何国家、国际组织或者地域实施的贸易限制、制裁或其他法律、规则限制的对象，否则您可能无法正常注册及使用激活助手服务。</p>
        
        <h3>2.2.账户注册</h3>
        <p>2.2.1.当您按照注册页面提示填写信息、阅读并同意本服务条款且完成全部注册程序后，您可获得激活助手账户并成为激活助手的用户。</p>
        <p>2.2.2.您可以通过设置或确认的账户名("账户名称")及您设置的密码完成注册程序;在您注册账户时，激活助手可能会为您自动生成一个"账号ID"。您理解并同意，当提及您的激活助手账户或者账号时，实际是指上述账户名称与密码、登录手机号或在用户界面内归属在"账户"或"账号"下的其他信息的统称。</p>
        <p>2.2.3.您设置的账户名不得违反国家法律法规、公序良俗、社会公德、激活助手的管理规范或容易引起您与激活助手身份的混淆，否则您的账户可能不能注册成功或激活助手有权经通知您后予以注销。</p>
        <p>2.2.4.您应当按照法律法规要求或按相应页面的提示，准确提供并及时更新您的账户信息，以使之真实、及时、完整和准确。如您提供的资料错误、不实、过时或不完整的，激活助手可以向您发出询问及/或要求改正的通知，您应按照激活助手的要求配合提供或者更新相关资料。因您填写的信息、资料不真实、不及时、不完整或不准确的，您应承担您不能使用激活助手账户(不能注册成功、或账户被冻结、注销)或您在使用过程中的后果和损失。</p>
        <p>2.2.5.通常情况下，您的账户是您在激活助手进行一切活动的唯一身份标识，除非另有约定，每一个激活助手账户都可以在本App独立开展活动。但在下列情形下，激活助手有权根据自己的判断，对同一及/或关联法律主体拥有的多个激活助手账户进行统一处理，如根据不同激活助手账户在注册、登录、使用中的关联信息，激活助手判断其实际为同一用户。关联信息举例:同一证件、同一手机号、同一设备、同一地址等。</p>
        
        <h3>2.3.账户的使用和安全</h3>
        <p>2.3.1.您有权使用您设定的账户登录激活助手，进而使用激活助手提供的服务。您知悉并同意，激活助手有权不时变更、暂停或取消任何一项服务(包括服务内容的调整、版本升级等)或整个服务，或不时变更、暂停或取消服务的某种特性或功能，或者不时变更、暂停或取消服务的使用方式及有关服务内容。该等变更、暂停或取消将在激活助手App上公布，以便通知到您。您有义务及时查收并透彻理解相关调整内容，如您不同意变更后的任何条款，请勿继续购买或使用相关服务。如您使用激活助手提供的服务，即视为您同意遵守届时公示的服务条款及该具体服务条款的最新版本及其任何条款。</p>
        <p>2.3.2.激活助手可能会以邮件、站内信、短信或电话等方式通知您相关服务进展情况以及提示您进行下一步的操作。在服务过程中您应当及时登录到激活助手查看和进行操作。</p>
        <p>2.3.3.一个激活助手账户仅能对应唯一的法律主体。除非有法律明文规定、司法裁定或者经激活助手同意的情况下,您不得以任何方式转让、转借、租售、赠与或让他人继承您的账户。</p>
        <p>2.3.4.您的账户信息由您自行设置并由您保管，您须对您的激活助手账户和密码、手机验证码及其他与账户相关的信息、资料予以保密。</p>
        <p>2.3.5.如发现他人未经授权使用您的激活助手账户，您应立即通知我们;我们将协助您冻结账户、更改密码或进行其他安全设置;您理解激活助手对您的请求采取行动需要合理时间,激活助手对在采取行动前已经产生的以及由您引发的后果(包括但不限于您的任何损失)不承担任何责任。</p>
      </section>
      
      <!-- App服务及规范 -->
      <section id="service">
        <h2>三、App服务及规范</h2>
        <p>3.1.您有权享受激活助手通过本App提供的技术服务和信息服务。</p>
        <p>3.2.您使用激活助手服务时，您应保证:</p>
        <p>3.2.1.您使用激活助手服务时将遵从国家、地方法律法规、行业惯例和社会公共道德,不会利用激活助手提供的服务进行发布、传播如下信息和内容:</p>
        <p>(i)违反国家法律法规政策的任何内容(信息);</p>
        <p>(ii)违反国家规定的政治宣传和/或新闻信息;</p>
        <p>(iii)涉及国家秘密和/或安全的信息;</p>
        <p>(iv)封建迷信和/或淫秽、色情、下流的信息或教唆犯罪的信息;</p>
        <p>(v)博彩有奖、赌博游戏;违反国家民族和宗教政策的信息;</p>
        <p>(ⅵ)妨碍互联网运行安全的信息;</p>
        <p>(ⅶ)侵害他人合法权益的信息和/或其他有损于社会秩序、社会治安、公共道德的信息或内容;</p>
        <p>(ⅷ)您同时承诺不得为他人发布上述不符合国家规定和/或本服务条款约定的信息内容提供任何便利，包括但不限于设置URL、BANNER链接等。</p>
        <p>3.2.2.不应出现任何破坏或试图破坏网络安全等的行为,包括不会利用技术或其他手段破坏或扰乱本App及其他App的服务;</p>
        <p>3.2.3.您使用激活助手的服务应符合本服务条款;</p>
        <p>如您违反上述保证,激活助手除有权根据相关服务条款采取删除信息、中止服务、终止服务的措施，并有权冻结或注销您账户部分或全部功能。</p>
      </section>
      
      <!-- 隐私及个人信息的保护 -->
      <section id="privacy">
        <h2>四、隐私及个人信息的保护</h2>
        <p>为及时跟进您的需求，我们可能会将您提供的联系人信息或账号数据(包含姓名、电话号码)，在必要时与您进行联络。</p>
      </section>
      
      <!-- 保密 -->
      <section id="confidentiality">
        <h2>五、保密</h2>
        <p>激活助手承诺对您注册账户时或使用激活助手服务时提交或知悉的信息采取保密措施，不向第三方披露您的信息，除非:</p>
        <p>5.1.依据本服务条款或者您与激活助手之间其他服务协议、在线条款等规定可以提供的;</p>
        <p>5.2.依据法律法规的规定或行政、司法等职权部门要求应当提供的;</p>
        <p>5.3.在不违反本服务条款约定责任的前提下,该保密信息已经公开或能从公开领域获得;</p>
        <p>5.4.为提供您要求的服务所必需。</p>
      </section>
      
      <!-- 出口管制及制裁 -->
      <section id="export">
        <h2>六、出口管制及制裁</h2>
        <p>双方承诺在遵守中华人民共和国出口管制及制裁等法律法规的前提下,同时遵守本合同所适用的其他出口管制及制裁法律法规。您承诺不会将激活助手提供的产品或服务用于军事、大规模杀伤性武器相关用户及用途，不会将激活助手提供的产品或服务用于所适用的出口管制及制裁法律法规禁止的用途。非经相关主管机关许可，您及您授权使用激活助手服务的其他个人或实体不会通过激活助手服务向适用的出口管制及制裁法律法规禁止的目的地、实体或个人提供受管控的产品、技术、软件或服务。</p>
      </section>
      
      <!-- 信息安全事件 -->
      <section id="security">
        <h2>七、信息安全事件</h2>
        <p>激活助手将及时响应信息安全事件，并依据国家法律法规的要求、遵照相关安全事件处理标准管理信息安全事件。当发生涉及您相关资产的信息安全事件时，我们会依法及时将事件相关的情况通过邮件、信函、电话、推送通知等方式告知，您也可通过工单、客服电话、邮箱等方式主动联系我们。</p>
      </section>
      
      <!-- 责任范围和责任限制 -->
      <section id="liability">
        <h2>八、责任范围和责任限制</h2>
        <p>8.1.您知悉并同意，您应承担因您使用本服务、违反本服务条款或在您的账户下采取的任何行动而导致的任何第三方索赔。如果由此引起微步及其关联公司、员工、客户和合作伙伴被第三方索赔的，您应负责处理，并赔偿微步及其关联公司由此遭受的全部损失和责任。</p>
        <p>8.2.在适用法律许可的范围内，激活助手不对与本服务条款有关或由本服务条款引起的任何间接的、惩罚性的、特殊的、派生的损失承担赔偿责任。</p>
        <p>8.3.激活助手在此提示，您在使用激活助手服务期间应当遵守中华人民共和国的法律，不得危害网络安全，不得利用激活助手的服务从事侵犯他人名誉、隐私、知识产权和其他合法权益的活动。激活助手不对您使用激活助手服务的违法或违约行为承担任何责任。</p>
      </section>
      
      <!-- 不可抗力和意外事件 -->
      <section id="force-majeure">
        <h2>九、不可抗力和意外事件</h2>
        <p>激活助手服务是按照现有技术和条件所能达到的现状提供的，激活助手会尽最大努力保障服务的连贯性和安全性,但不能随时预见和防范法律、技术以及其他风险，在法律允许的范围内，如因下列不可抗力或意外事件无法正常提供服务的，激活助手不承担任何法律责任:</p>
        <p>9.1.不可抗力,即双方所不能预见、并且它的发生及其后果是不能克服和不能避免的客观情况，包括但不限于如下情形:(1)自然灾害如洪水、冰雹、海啸、台风、旱灾、火灾;(2)社会因素如罢工、暴乱、战争及所适用的政策、法律、法规导致不能履行;</p>
        <p>9.2.因电力供应故障、通讯网络故障等公共服务因素;</p>
        <p>9.3.因黑客攻击、病毒、您自身软硬件设备异常等非激活助手独立责任;</p>
        <p>9.4.经提前公告或通知的,激活助手在短时间内的系统维护(包括但不限于排除故障、系统升级、系统扩容、服务器迁移)。</p>
      </section>
      
      <!-- 法律适用与管辖 -->
      <section id="jurisdiction">
        <h2>十、法律适用与管辖</h2>
        <p>本服务条款之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因本服务条款产生之争议应提交至烟台微步网络科技有限公司注册地所在地的法院。</p>
      </section>
      
      <!-- 通知送达 -->
      <section id="notice">
        <h2>十一、通知送达</h2>
        <p>11.1.您理解并同意，激活助手可通过电子邮件、站内信、短信、电话、系统消息以及即时通信等以上一种或多种通知方式向您发送通知,且激活助手可以信赖您所提供的联系信息是完整、准确且当前有效的;上述通知在发送成功后视为已送达。</p>
        <p>11.2.除非本服务条款另有约定或激活助手与您另行签订的协议明确规定了通知方式，您发送给激活助手的通知，应当通过激活助手对外正式公布的通信地址、电子邮件地址等联系信息进行送达。</p>
      </section>
      
      <!-- 条款的更新和终止 -->
      <section id="update">
        <h2>十二、条款的更新和终止</h2>
        <p>12.1.激活助手有权对本服务条款及相应的服务规则内容进行变更，并将用电子邮件、站内信、短信等方式予以公告或通知;若您在本服务条款内容变更后继续使用本服务的，表示您已充分阅读、理解并接受修改后的内容，也将遵循修改后的条款内容。</p>
        <p>12.2.在您的账户注销或经双方协商一致终止服务的，本服务条款终止。</p>
      </section>
      
      <!-- 其他 -->
      <section id="other">
        <h2>十三、其他</h2>
        <p>13.1.本服务条款由本服务条款的内容、相关页面上展现的规则、规范，服务说明(含操作文档)和您点击确认的其他条款/条件组成，激活助手和您均受其约束，且其中的相关名词可相互引用、解释。</p>
        <p>13.2.本服务条款的章节标题仅为行文方便而设，不具有法律或合同效力。</p>
        <p>13.3.本服务条款任一条款被视为废止、无效或不可执行，该条款应视为可分的且不影响本服务条款及其他条款的有效性及可执行性。</p>
        <p>13.4.除另有约定外，出于服务专业性考虑，激活助手亦可能委托关联公司或其他法律主体向您提供激活助手上一项或多项具体服务，同时您可能会与该等公司订立相关条款或条件，请您审慎阅读、充分理解条款和条件内容，选择接受或不接受该条款和条件。</p>
        <p>13.5.本服务条款项下之保密条款、法律适用与管辖条款以及性质上理应存续的其他条款(如对注册信息的真实性保证等)，不因本条款的终止而失效。</p>
        <p>13.6.激活助手将严格遵守自愿、平等、公平、诚信的合作原则，充分尊重合作方的自主经营权利。如发现微步员工存在违反上述合作原则的不当行为，可以通过激活助手监督邮箱jihuozhushou@163.com反映问题，微步将遵循保密、客观的原则开展调查和处理。</p>
      </section>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'UserAgreement',
  data() {
    return {
      sections: [
        { id: 'preface', title: '前言' },
        { id: 'subject', title: '一、签约主体以及协议范围' },
        { id: 'account', title: '二、账户的注册、使用与安全' },
        { id: 'service', title: '三、App服务及规范' },
        { id: 'privacy', title: '四、隐私及个人信息的保护' },
        { id: 'confidentiality', title: '五、保密' },
        { id: 'export', title: '六、出口管制及制裁' },
        { id: 'security', title: '七、信息安全事件' },
        { id: 'liability', title: '八、责任范围和责任限制' },
        { id: 'force-majeure', title: '九、不可抗力和意外事件' },
        { id: 'jurisdiction', title: '十、法律适用与管辖' },
        { id: 'notice', title: '十一、通知送达' },
        { id: 'update', title: '十二、条款的更新和终止' },
        { id: 'other', title: '十三、其他' }
      ]
    }
  },
  methods: {
  },
  mounted() {
    // 页面加载时滚动到顶部
  }
}
</script>

<style scoped>
.agreement-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Microsoft YaHei', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  color: #333;
  font-size: 14px;
}

.agreement-header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ddd;
}

.agreement-header h1 {
  font-size: 22px;
  margin-bottom: 10px;
}

.effective-dates {
  display: flex;
  justify-content: center;
  gap: 30px;
  color: #666;
  font-size: 13px;
}

/* 目录样式 */
.toc {
  background-color: #f8f9fa;
  padding: 15px;
  margin-bottom: 20px;
}

.toc h2 {
  font-size: 16px;
  margin-bottom: 10px;
}

.toc ul {
  padding-left: 20px;
}

.toc li {
  margin-bottom: 6px;
  line-height: 1.5;
}

.toc a {
  color: #3498db;
  text-decoration: none;
}

.toc a:hover {
  text-decoration: underline;
}

/* 内容样式 */
.agreement-content {
  margin-bottom: 30px;
}

.agreement-content section {
  margin-bottom: 30px;
}

h2 {
  font-size: 18px;
  margin: 25px 0 10px;
  padding-bottom: 5px;
  border-bottom: 1px solid #eee;
  font-weight: bold;
}

h3 {
  font-size: 16px;
  margin: 20px 0 8px;
  font-weight: bold;
}

p {
  margin-bottom: 12px;
  text-align: justify;
}

.important {
  background-color: #fff8e1;
  padding: 10px;
  margin: 15px 0;
}

/* 同意按钮 */
.accept-container {
  text-align: center;
  margin: 30px 0;
}

.agree-button {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 12px 30px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.agree-button:hover {
  background-color: #2980b9;
}

/* 页脚 */
footer {
  text-align: center;
  margin-top: 30px;
  padding-top: 15px;
  border-top: 1px solid #ddd;
  color: #777;
  font-size: 12px;
}
</style>
